export default {
  LOG_WARNING: 'LOG_WARNING',
  LOG_ERROR: 'LOG_ERROR',
};
